<template>
  <div>
    <BlockUI v-if="loading"></BlockUI>
    <TituloComponent
      icono-titulo="fas fa-users"
      texto-titulo="Cuentas corrientes"
    ></TituloComponent>
    <div class="main-card mb-3 card col-12">
      <div class="card-body">
        <DataList  ref="datatable" url="/clientes" :fields="fields" :rowClick="verCliente" :toCuil="toCuil" :toPesos="toPesos"></DataList>
      </div>
    </div>
  </div>
</template>
<script>
import TituloComponent from "@/components/layouts/TituloComponent";
import DataList from "@/components/layouts/DataList";
import BlockUI from "@/components/loaders/BlockUI";
export default {
  name: "CuentasCorrientes",
  components: {
    TituloComponent,
    DataList,
    BlockUI
  },
  data() {
    return {
      fields: [
        {
          name: "codigo",
          label: "Código",
          type: "title",
          class: "",
          append: ' - '
        },
        {
          name: "nombre",
          label: "Nombre",
          type: "title",
          class: "text-success",
          append: ' - '
        },
        {
          name: "saldo",
          label: "Saldo",
          type: "title",
          class: "text-danger",
          prepend: '$'
        },
        {
          name: "numero_documento",
          label: "N° documento",
          type: "field",
          class: "text-alternate",
        },
        {
          name: "domicilio",
          label: "Domicilio",
          type: "field",
          class: ""
        },
      ],
      toCuil:['numero_documento'],
      toPesos: ['saldo'],
      loading: false
    };
  },
  methods: {
    verCliente(cliente){
      this.$router.push({name:'VerCliente', params:{id:cliente.id}});
    }
  }
};
</script>